import React from 'react';
import { Grid } from '@material-ui/core';
import { Form } from 'formik';
import styled from 'styled-components';
// type InlineFormCardProps = GridProps<ElementType<HTMLFormElement>>;
const StyledInlineFormGrid = styled(Grid) `
  h3 {
    font-size: 32px;
  }
  h5 {
    font-size: 14px;
  }
`;
export const InlineForm = props => {
    const { spacing = 2, children } = props;
    return (React.createElement(StyledInlineFormGrid, Object.assign({ container: true, component: Form, wrap: 'wrap', spacing: spacing }, props), children));
};
export default InlineForm;
//# sourceMappingURL=InlineForm.js.map